<template>
  <component :is="event.type" v-model="event.value"></component>
</template>

<script>
  import Events from './events'

  export default {
    components: {
      ...Events
    },
    props: ['event']
  }
</script>

<style></style>
